import * as React from "react";

import { mergeOverrides } from "baseui/helpers/overrides";
import { Tag as BaseTag, TagProps, SIZE, VARIANT } from "baseui/tag";

const Tag: React.FC<TagProps> = (props) => {
  const { children, ...restProps } = props;
  return (
    <BaseTag
      closeable={restProps.closeable || false}
      size={restProps.size || SIZE.medium}
      variant={restProps.variant || VARIANT.solid}
      kind={restProps.kind}
      {...restProps}
      overrides={
        restProps.overrides ? mergeOverrides(overrides, restProps.overrides) : overrides
      }
    >
      {children}
    </BaseTag>
  );
};

const overrides: TagProps["overrides"] = {
  Root: {
    style: ({ $theme }) => ({
      lineHeight: $theme.sizing.scale850,
      paddingLeft: $theme.sizing.scale700,
      paddingRight: $theme.sizing.scale700,
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0,
    }),
  },
  Text: {
    style: {
      maxWidth: "auto",
      textOverflow: "none",
      fontSize: "0.75rem",
    },
  },
};

export { Tag };
